import { useNavigate, useParams } from 'react-router-dom';
import { 
  Modal, 
  ModalDialog, 
  ModalClose, 
  Typography, 
  Stack, 
  Button, 
  Alert,
  Box 
} from '@mui/joy';
import { 
  useCreateRecipeFromURLMutation
} from '../api';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider } from 'react-hook-form';
import { FormInput } from '@/components/forms/FormInput';
import LinkIcon from '@mui/icons-material/Link';
import { fromURLSchema, newFromURL } from '../schema';

export function AddRecipeFromURLPage() {
  const { householdId } = useParams();
  const navigate = useNavigate();
  const [createFromURL, { isLoading, error }] = useCreateRecipeFromURLMutation();

  const form = useForm({
    defaultValues: newFromURL(),
    resolver: yupResolver(fromURLSchema)
  });

  const handleClose = () => {
    form.reset();
    navigate(`/h/${householdId}/recipes`);
  };

  async function onSubmit(data) {
    try {
      const result = await createFromURL({ householdId, url: data.url.trim() }).unwrap();
      form.reset();
      navigate(`/h/${householdId}/recipes/${result.data.id}`);
    } catch (err) {
      console.error('Failed to import recipe from URL:', err);
    }
  }

  return (
    <Modal open={true} onClose={handleClose} disableRestoreFocus>
      <ModalDialog sx={{ maxWidth: '500px', width: '90%' }}>
        <ModalClose />
        <Typography level="h4" sx={{ mb: 1 }}>
          Add Recipe from URL
        </Typography>
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <Stack spacing={3}>
              {error && (
                <Alert color="danger">
                  {error.data?.error || error.message || 'Failed to add recipe'}
                </Alert>
              )}
              
              <Box>
                <Typography level="body-sm" sx={{ mb: 1 }}>
                  Paste a recipe URL to automatically extract recipe information
                </Typography>
                <FormInput                  
                  inputProps={{ autoFocus: true }}
                  name="url"
                  type="url"
                  placeholder="https://example.com/recipe"
                  startDecorator={<LinkIcon />}
                />
              </Box>
              
              <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ mt: 2 }}>
                <Button variant="outlined" color="neutral" onClick={handleClose}>Cancel</Button>
                <Button type="submit" loading={isLoading} sx={{ px: 2.5 }}>Add Recipe</Button>
              </Stack>
            </Stack>
          </form>
        </FormProvider>
      </ModalDialog>
    </Modal>
  );
}
